import 'components/select';
import 'utils/filter_form';
import 'utils/autofill_by_query_string';
import './index.scss';

(function () {
  'use strict';

  const $filterForm = $('#js-professors-filter-form');
  $filterForm
    .autoFillByQueryString()
    .filterForm();

})(jQuery);
